import { defineStore } from 'pinia'
import { toRefs } from 'vue'
import { createState, resetState } from './state'
import { createActions } from './actions'
import { createGetters } from './getters'

export const useTasksStore = defineStore('tasks', () => {
  const state = createState()
  const actions = createActions(state)
  const getters = createGetters(state)

  const $reset = () => {
    resetState(state)
  }

  return {
    ...toRefs(state),
    ...actions,
    ...getters,
    $reset,
  }
})
